// extracted by mini-css-extract-plugin
export default {"wrapper":"PageLoader_wrapper__w5CIH","label":"PageLoader_label__JSV+W"};